import React, { useEffect, useState } from "react";
import { useNavigate,useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Typography, Box , Button} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// import { getDiscourseByTitle } from "../../../services/database/database_service";

import YouTubePlayer from "./YoutubePlayer";
import LoadingIndicator from "../components/LoadingIndicator";
import { useLanguage } from "../../../services/localization/LanguageContex";

function DiscourseSubScreenTwo() {
  const { t } = useLanguage();
  const { type,discourseTitle } = useParams();


  const dataList = useSelector((state) => state.discourse.discourseData);
  const [discourseData, setDiscourseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  

  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(-1);

  useEffect(() => {
    window.scrollTo(0, 0);
    if(!dataList||dataList.length===0){
      navigate(`/home/discourse/${type}`);
      return;
    }
      try {
        const index = dataList.findIndex(
          (item) => item.discourseTitle === decodeURIComponent(discourseTitle)
        );
        if (index !== -1) {
          setCurrentIndex(index);
          setDiscourseData(dataList[index]);
        }
     
      } catch (err) {
        setError('Could not fetch data. Please try again later.');
      } finally {
        setLoading(false);
      }

  }, [discourseTitle]);

  return (
    <Box
      sx={{
        px: { xs: 1, sm: 6, md: 6 },
        pt: 1, pb:4
      }}
    >
      <>
        <Typography variant="h4" gutterBottom align="center"
            sx={{
              fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" },
            }}
        >
          {t(discourseTitle)}
        </Typography>

        <Box
          sx={{
            mx: "auto", mt:1,
            maxWidth: 900,
            backgroundColor: "white", // background color for the card
          }}
        >
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              {/* <CircularProgress /> */}
              <LoadingIndicator/>
            </Box>
          ) : error ? (
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Typography variant="h6" color="error">
                {error}
              </Typography>
            </Box>
          ) : Object.keys(discourseData).length === 0 ? (
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Typography variant="h6" color="textSecondary" gutterBottom>
                Data not found.
              </Typography>
              <Typography variant="body1" color="textSecondary">
                Please check back later.
              </Typography>
            </Box>
          ) : (
            <>
              <YouTubePlayer url={discourseData.discourseUrl} />
              <Typography variant="body1" align="center" sx={{ mt: 1 }}>
                {t(discourseData.discourseDescription)}
              </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // px: 2,
                pt: 1,
              }}
            >
              <Button
                onClick={() => navigate(`/home/discourse/${encodeURIComponent(type)}/${encodeURIComponent(dataList[currentIndex - 1].discourseTitle)}`)}
                disabled={currentIndex <= 0}
                startIcon={<ArrowBackIosIcon />}
                variant="outlined"
              >
                {/* Previous */}
              </Button>

              <Button
                onClick={() => navigate(`/home/discourse/${encodeURIComponent(type)}/${encodeURIComponent(dataList[currentIndex + 1].discourseTitle)}`)}
                disabled={currentIndex >= dataList.length - 1}
                endIcon={<ArrowForwardIosIcon />}
                variant="outlined"
              >
                {/* Next */}
              </Button>
            </Box>
            </>
          )}
        </Box>
      </>
    </Box>
  );
}

export default DiscourseSubScreenTwo;
